// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"197":"39a08cf2","212":"af2f473f","396":"07423149","412":"db361b44","421":"25b1d5ea","655":"d3e4275c"}[chunkId] + ".chunk.css";
};